export const CompanyDebitProcessType = {
  Preprocess: "preprocess",
  Process: "process",
  RePreprocess: "repreprocess",
} as const;

export type CompanyDebitProcessType =
  (typeof CompanyDebitProcessType)[keyof typeof CompanyDebitProcessType];
